<template>
  <section class="ui-game">
    <GameScore />

    <footer class="ui-game__footer">
      <GamePowerupPercentage />

      <GameLife />
    </footer>
  </section>
</template>

<script>
import GameLife from '@/components/GameLife.vue';
import GameScore from '@/components/GameScore.vue';
import GamePowerupPercentage from '@/components/GamePowerupPercentage.vue';

export default {
  name: 'UIendGame',

  components: {
    GameLife,
    GameScore,
    GamePowerupPercentage,
  },
};
</script>

<style lang="scss" scoped>
.ui-game {
  text-align: center;
  color: $white;

  &__footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;

    padding: 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    @include mq(ipadP) {
      padding: 30px;
    }

    @include mq(dm) {
      padding: 40px;
    }
  }
}
</style>
